import { render, staticRenderFns } from "./ProfileQuestions.vue?vue&type=template&id=98be85da&scoped=true"
import script from "./ProfileQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileQuestions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfileQuestions.vue?vue&type=style&index=0&id=98be85da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98be85da",
  null
  
)

export default component.exports